import cn from 'clsx';

type AvatarProps = {
  initials: string;
  size?: 'sm' | 'md' | 'lg';
  extraClassName?: string;
};

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
};

export function BasicAvatar({
  initials,
  size = 'md',
  extraClassName = '',
}: AvatarProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-pm-blue text-white font-semibold select-none',
        extraClassName,
        sizeClasses[size],
      )}
      aria-label={`Avatar ${initials}`}
    >
      {initials}
    </div>
  );
}
